import { useCallback, useEffect } from 'react';
import { useLabelContext } from './labelContext';

export default function useBeforeUnload(
    hasPendingChanges,
    isCreateMode,
    overrideUnload = false
) {
    const { dashboardLabels } = useLabelContext();

    // eslint-disable-next-line complexity
    const onUnload = useCallback(
        (event) => {
            if ((hasPendingChanges || isCreateMode) && !overrideUnload) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = dashboardLabels.unsavedChanges;
            }
        },
        [dashboardLabels, hasPendingChanges, isCreateMode, overrideUnload]
    );

    useEffect(() => {
        window.addEventListener('beforeunload', onUnload);

        return () => {
            window.removeEventListener('beforeunload', onUnload);
        };
    }, [onUnload]);
}
